/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_Status_ShippedInputs */

const en_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

const es_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

const fr_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expédié`)
};

const de_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versendet`)
};

const ja_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発送済み`)
};

const zh_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发货`)
};

const ar_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الشحن`)
};

const id_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikirim`)
};

const it_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spedito`)
};

const ru_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправлено`)
};

const pt_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

const ko_book_status_shipped = /** @type {(inputs: Book_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배송됨`)
};

/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {Book_Status_ShippedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_status_shipped = /** @type {((inputs?: Book_Status_ShippedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_Status_ShippedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_status_shipped(inputs)
	if (locale === "es") return es_book_status_shipped(inputs)
	if (locale === "fr") return fr_book_status_shipped(inputs)
	if (locale === "de") return de_book_status_shipped(inputs)
	if (locale === "ja") return ja_book_status_shipped(inputs)
	if (locale === "zh") return zh_book_status_shipped(inputs)
	if (locale === "ar") return ar_book_status_shipped(inputs)
	if (locale === "id") return id_book_status_shipped(inputs)
	if (locale === "it") return it_book_status_shipped(inputs)
	if (locale === "ru") return ru_book_status_shipped(inputs)
	if (locale === "pt") return pt_book_status_shipped(inputs)
	return ko_book_status_shipped(inputs)
});